import { NavWebStatsOverview } from '@va/icons';
import { useTranslate } from '@va/localization';
import { contributorRole } from '@va/standalone/shared/selectors';
import { IconWithBackground, ToggleActionCard } from '@va/ui/design-system';
import { useSelector } from 'react-redux';
import { ErrorAlertsThreshold } from './ErrorAlertsThreshold';
import useErrorAlertsPreferences from './useErrorAlertsPreferences';

export const ErrorAlertsToggle = () => {
  const translate = useTranslate();
  const isContributor = useSelector(contributorRole);
  const { formValues, handleActivateToggleChange } = useErrorAlertsPreferences();

  return (
    <ToggleActionCard
      title={translate('form.errorAlerts.activateToggle')}
      name={'activateErrorAlerts'}
      className='p-3 pr-5'
      subSectionClass={'p-3! pl-1.5'}
      value={formValues.abeActivated}
      handleChange={({ value }) => handleActivateToggleChange(value)}
      disabled={isContributor}
      infoTooltip={isContributor ? translate('tooltips.contributorRole') : undefined}
      icon={() => <IconWithBackground className='bg-white' icon={() => <NavWebStatsOverview />} />}
    >
      <ErrorAlertsThreshold />
    </ToggleActionCard>
  );
};
